import { render } from "./closeInAppBrowser.vue?vue&type=template&id=59666fa1&ts=true"
import script from "./closeInAppBrowser.vue?vue&type=script&lang=ts"
export * from "./closeInAppBrowser.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__